<script>
import ManageAccountAttachments from '@/views/Application/Manage/Accounts/Account/Attachments'

export default {
  extends: ManageAccountAttachments,
  data () {
    return {
      breadcrumb: {
        name: 'Attachments',
        route: { name: 'sales-accounts-account-attachments', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
